import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/inventory-list-by-warehouses', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const header = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/inventory-list-by-warehouses/headers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const exportExcel = data => {
  return httpClient
    .post('/api/v1/reports/inventory-list-by-warehouses/export-excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.resolve(error.response.data))
}
export default { get, header, exportExcel }
